var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnections(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.25C4.64746 10.25 5.375 9.52246 5.375 8.625C5.375 7.72754 4.64746 7 3.75 7C2.85254 7 2.125 7.72754 2.125 8.625C2.125 9.52246 2.85254 10.25 3.75 10.25Z",
    stroke: "#AF4ED1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.25C11.1475 10.25 11.875 9.52246 11.875 8.625C11.875 7.72754 11.1475 7 10.25 7C9.35254 7 8.625 7.72754 8.625 8.625C8.625 9.52246 9.35254 10.25 10.25 10.25Z",
    stroke: "#AF4ED1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.75C7.89746 3.75 8.625 3.02246 8.625 2.125C8.625 1.22754 7.89746 0.5 7 0.5C6.10254 0.5 5.375 1.22754 5.375 2.125C5.375 3.02246 6.10254 3.75 7 3.75Z",
    stroke: "#AF4ED1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5C7 11.7051 5.54491 10.25 3.75 10.25C1.95507 10.25 0.5 11.7051 0.5 13.5",
    stroke: "#AF4ED1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5C13.5 11.7051 12.0449 10.25 10.25 10.25C8.45509 10.25 7 11.7051 7 13.5",
    stroke: "#AF4ED1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7C10.25 5.20509 8.79491 3.75 7 3.75C5.20509 3.75 3.75 5.20509 3.75 7",
    stroke: "#AF4ED1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/Connections.880d5773d35c6885eb94a900a0ae9642.svg";
export { ForwardRef as ReactComponent };